<template>
        <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37">
  <g id="Group_149" data-name="Group 149" transform="translate(-1575 -28.616)">
    <path id="ic_person_24px" d="M19.888,19.734a7.867,7.867,0,1,0-7.867-7.867A7.865,7.865,0,0,0,19.888,19.734Zm0,.406-.316,0c-5.06.029-15.049,1.782-15.049,6.982l6.1,6.339,13.526,2.019,10.74-7.873C34.885,22.378,25.139,20.14,19.888,20.14Z" transform="translate(1573.541 29.036)" fill="#2ECC71"/>
    <g id="Ellipse_80" data-name="Ellipse 80" transform="translate(1575 28.616)" fill="none" stroke="#2ECC71" stroke-width="3">
      <circle cx="18.5" cy="18.5" r="18.5" stroke="none"/>
      <circle cx="18.5" cy="18.5" r="17" fill="none"/>
    </g>
  </g>
</svg>
</template>

<script>
export default {

}
</script>

<style>

</style>